import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function ScraperHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const businesses = [{
    name: 'The daily grind coffee co.',
    contact: '+1 212-555-0100',
    email: 'info@dailygrind.com',
    rating: '4.7'
  }, {
    name: 'Fresh bites bakery',
    contact: '+1 310-555-0101',
    email: 'hello@freshbites.com',
    rating: '4.9'
  }, {
    name: 'Urban canvas art studio',
    contact: '+1 415-555-0102',
    email: 'contact@urbancanvas.net',
    rating: '4.5'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-2155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2156">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-2157">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-2158" /> All features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-2159">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-2160">
            <h1 className="text-6xl sm:text-7xl lg:text-[5.5rem] font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-2161">
              <span className="text-blue-600" data-id="element-2162">Google Maps</span> <br data-id="element-2163" />
              scraper & <br data-id="element-2164" />
              extractor
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-2165">
              The best Google Places API alternative for extracting google local
              business data. Use our google map scraper to get{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-2166">
                business emails
              </span>
              ,{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1" data-id="element-2167">
                phone numbers
              </span>
              , and{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-purple-50 text-purple-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-2168">
                reviews & ratings
              </span>{' '}
              in minutes. Also works as a powerful google reviews scraper and
              google maps phone number scraper.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-2169">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-2170">
                Try for free
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-2171">
              <div data-id="element-2172">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2173">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2174">
                  Local businesses indexed
                </div>
              </div>
              <div data-id="element-2175">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2176">
                  50+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2177">
                  Data fields per business
                </div>
              </div>
              <div data-id="element-2178">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-2179">
                  Weekly
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-2180">
                  Data updates
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-2181">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-2182">
              <div className="flex justify-between items-center mb-8" data-id="element-2183">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-2184">
                  Google Maps data preview
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-2185">
                <table className="w-full text-sm text-left" data-id="element-2186">
                  <thead data-id="element-2187">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-2188">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-2189">
                        Local business
                      </th>
                      <th className="pb-4 px-4 font-medium" data-id="element-2190">Contact info</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-2191">Email</th>
                      <th className="pb-4 pl-4 font-medium hidden sm:table-cell" data-id="element-2192">
                        Rating
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-2193">
                    {businesses.map((biz, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-2194">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl" data-id="element-2195">
                          {biz.name}
                        </td>
                        <td className="py-6 px-4 text-slate-600" data-id="element-2196">
                          <div className="whitespace-nowrap" data-id="element-2197">{biz.contact}</div>
                        </td>
                        <td className="py-6 pl-4 text-blue-600 truncate max-w-[120px] sm:max-w-none" data-id="element-2198">
                          {biz.email}
                        </td>
                        <td className="py-6 pl-4 hidden sm:table-cell rounded-r-xl" data-id="element-2199">
                          <span className="text-slate-600 font-medium" data-id="element-2200">
                            ⭐ {biz.rating}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              {/* Export button */}
              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-2201">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-2202">
                  Export data
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}